import Minze, { MinzeElement } from 'minze'
import { Font } from '../../constants'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'accountLoading', {
  status: 'Chargement de la page en cours...',
  message: 'Ça s’en vient!',
})

Locale.getInstance().registerKeySet('en', 'accountLoading', {
  status: 'Page loading...',
  message: "It's coming!",
})

export class LvcAccountLoading extends MinzeElement {
  html = () => {
    return `
			<div class="loading-block">
				<lvc-charlie-hands-together-full-body></lvc-charlie-hands-together-full-body>
				<div class="message">
					${Locale.getKey('accountLoading.message')}
				</div>
				<div class="status">
					${Locale.getKey('accountLoading.status')}
				</div>
			</div>
		`
  }

  css = () => {
    return `
			:host {
				position: fixed;
				width: 100vw;
				height: 100vh;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 1000;
				display: grid;
				grid-template-rows: 33vh 33vh 33vh;
				grid-template-columns: 33vw 33vw 33vw;
			}

			.loading-block {
				grid-column: 2;
				grid-row: 2;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				position: relative;
			}

			.status { 
				color: #1E007D;
				font-family: ${Font.family};
				font-weight: ${Font.weight.medium};
				white-space: nowrap;
			}

			.message {
				position: absolute;
				left: 50%;
				margin-left: 90px;
				margin-top: -128px;
				top: 50%;
				padding: 8px;
				border-radius: 2px;
				background: #DCFFD7;
				color: #1E007D;
				white-space: nowrap;
				font-family: ${Font.family};
				font-weight: ${Font.weight.medium};
			}
			
			@media screen and (max-width: 420px) {
				.message {
					margin-top: -180px;
					margin-left: 0;
				}
			}
		`
  }
}
